import { z } from 'zod';
import { AI_TIERS } from './job-types.js';
/**
 * `image_generator` (spec 80 section 4.11, ADR-025, S140-7): one image from an
 * editor's description, generated through the license platform gateway and
 * stored by module 30 as an asset of origin `ai_generated`. The run's `params`
 * carry the property, the description and the format; the image bytes never
 * enter the run log.
 */
export const IMAGE_GENERATOR_FORMATS = ['square', 'portrait', 'story', 'landscape'];
export const IMAGE_GENERATOR_LIMITS = {
    minPromptLength: 3,
    /** The platform accepts 4000; the guard sentences of REQ-BILD-005 take the rest. */
    maxPromptLength: 3000,
};
/**
 * Credits of one image (platform doc `14-saas-api`, S140-7): the platform's
 * base price of task `image_generator` (provisional 10) times the tier's
 * credit factor (decision 2 of 2026-10-02: x1, x3, x5). Shown before the
 * start (REQ-BILD-001); the platform's ledger stays the billing source.
 */
export const IMAGE_GENERATOR_BASE_CREDITS = 10;
export const AI_TIER_CREDIT_FACTORS = { basic: 1, better: 3, best: 5 };
export function imageGeneratorCredits(tier) {
    return IMAGE_GENERATOR_BASE_CREDITS * AI_TIER_CREDIT_FACTORS[tier];
}
export const imageGeneratorInputSchema = z.object({
    property_id: z.uuid(),
    prompt: z.string().trim().min(IMAGE_GENERATOR_LIMITS.minPromptLength).max(IMAGE_GENERATOR_LIMITS.maxPromptLength),
    format: z.enum(IMAGE_GENERATOR_FORMATS),
});
/** What the run log keeps of a generated image: never the bytes. */
export const imageGeneratorOutputSchema = z.object({
    media_type: z.enum(['image/jpeg', 'image/png', 'image/webp']),
    width: z.number().int().positive().nullable(),
    height: z.number().int().positive().nullable(),
    size_bytes: z.number().int().positive(),
    model: z.string().min(1).max(200),
    credits_charged: z.number().nonnegative(),
    /** The tier the image was generated in; stored on the asset as provenance. */
    tier: z.enum(AI_TIERS),
});
//# sourceMappingURL=image-generator.js.map